// Auto-generated by scripts/sync-icons.ts. Do not edit by hand.
// Source: react-icons/hi -> HiReceiptRefund
import type { IconBaseProps } from "..";

export function HiReceiptRefund({ size, color, style, ...rest }: IconBaseProps) {
  const computedStyle = color ? { color, ...style } : style;
  const dim = size ?? "1em";
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 20 20"
      aria-hidden="true"
      width={dim}
      height={dim}
      {...rest}
      style={computedStyle}
    >
      <path
        fillRule="evenodd"
        d="M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm4.707 3.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L8.414 9H10a3 3 0 013 3v1a1 1 0 102 0v-1a5 5 0 00-5-5H8.414l1.293-1.293z"
        clipRule="evenodd"
      />
    </svg>
  );
}
